<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<main id="content" role="main" class="main">
    <!-- Content -->
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w1" class="breadcrumb">
                    <li class="breadcrumb-item">الرئيسية</li>
                    <li class="breadcrumb-item active" aria-current="page">الاعفائات</li>
                </ol>
            </nav>
        </div>
        <div class="user-index" >

            <div class="row">

                <div class="col-md-6 col-12">
                    <label for="stopReason"> الرقم الضريبي</label>
                    <input type="text" class="form-control" name="taxNumber" [(ngModel)]="taxNumber" (blur)="search()">
                </div>

                <div class="col-md-6 col-12">
                    <label for="stopReason"> رقم الرخصة </label>
                    <input type="text" class="form-control" name="licenseId" [(ngModel)]="licenseId" (blur)="search()">
                </div>
            </div>

            <br>
            <br>

            <h1>الاعفائات</h1>


            <div id="w0" class="grid-view">
                <!-- <div class="summary">Showing <b>1-20</b> of <b>3,726</b> items.</div> -->
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>الرقم الضريبي</th>
                            <th>الرمز الاضافي</th>
                            <th>تاريخ الاعفاء</th>
                            <th>حالة الاعفاء</th>
                            <th>تاريخ الايقاف </th>
                            <th>سبب الايقاف </th>
                            <th></th>
                           
                        </tr>
                    </thead>
                    <tbody>
                        <tr data-key="1" *ngFor="let item of requests;let i=index">
                            <td>
                                {{i+1}}
                            </td>
                            <td>
                                {{item?.taxNumber}}
                            </td>
                            <td>
                                {{item?.licenseId}}
                            </td>
                            <td>
                                {{item?.createdDate|date:'dd-MM-yyyy'}}
                            </td>
                            <td>
                                {{item?.isStoped==false?'فعال':'غير فعال'}}
                            </td>
                            <td>
                                {{item?.stoppedMainGamarekTaxExemption[0]?.createdDate|date:'dd-MM-yyyy'}}
                                <div *ngIf="item?.stoppedMainGamarekTaxExemption[0]" class="text-primary" role="button" (click)="downloadMinioFile(item?.stoppedMainGamarekTaxExemption[0]?.attachment)"> المرفق </div>
                            </td>
                            <td>
                                {{item?.stoppedMainGamarekTaxExemption[0]?.stopReason}}
                            </td>
                            
                            <td style="display: flex;"><a href="/{{mainPath}}/Jamarek?Carponcopyid={{item.carbonId}}&TaxNumber={{item?.taxNumber}}&Token={{token}}" target="_blank" title="View" aria-label="View" data-pjax="0"><svg
                                        aria-hidden="true"
                                        style="display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em;width:1.125em"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path fill="currentColor"
                                            d="M573 241C518 136 411 64 288 64S58 136 3 241a32 32 0 000 30c55 105 162 177 285 177s230-72 285-177a32 32 0 000-30zM288 400a144 144 0 11144-144 144 144 0 01-144 144zm0-240a95 95 0 00-25 4 48 48 0 01-67 67 96 96 0 1092-71z">
                                        </path>
                                    </svg></a>

                                <div *ngIf="!item?.isStoped" (click)="showDialog(item.licenseId)" class="px-2" role="button">
                                    <svg style="color: red" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stop-fill" viewBox="0 0 16 16"> <path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z" fill="red"></path> </svg>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ul class="pagination">
                    <li class="prev"><span (click)="goPrevIndex()">«</span></li>
                   
                    <li [ngClass]="item==currentIndex?'active':null" *ngFor="let item of pages| slice:currentIndex-1:currentIndex+9"><a (click)="updatePagination(item)">{{item}}</a></li>
                    <li class="next"><a (click)="goNextIndex()" data-page="1">»</a></li>
                </ul>
            </div>

        </div>
    </div>
    <!-- End Content -->
</main>

<p-dialog header="ايقاف الاعفاء" [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
   
    <form [formGroup]="stopForm">

        <div class="row">
            <div class="col-12">
                <label for="stopReason"> سبب الايقاف </label>
                <textarea id="stopReason" class="form-control" formControlName="stopReason" cols="10"></textarea>
                <div class="text-danger" *ngIf="stopForm.controls.stopReason.errors?.required && isClick">
                    حقل اجباري
                </div>
            </div>

            <div class="col-12 py-2">
                <label for="attachment"> المرفق </label>
                <input id="attachment" class="form-control" type="file" (change)="onUploadFile($event)" formControlName="attachment">
                <div class="text-danger" *ngIf="stopForm.controls.attachment.errors?.required && isClick">
                    حقل اجباري
                </div>
            </div>

            <div class="col-12 text-center">
                <button class="btn btn-primary" (click)="stopLicense()"> حفظ </button>
            </div>

        </div>
       
      </form>
    
</p-dialog>